module.exports = __webpack_public_path__ + "img/thumbnail_StripedSkunk_m_erythristic.c14752b9.png";